import React from 'react';
import { useField } from 'formik';
import Input from 'app/common/components/Elements/Input';
import { InputTextFieldProps } from './types';

const InputTextField: React.FC<InputTextFieldProps> = ({ validate, wrapClassName, label, className, tips, onChange, ...props }) => {
  const [field, meta] = useField({ name: props.name, validate });

  /**
   * @description 處理 onChange 執行的事件
   * @param event event object
   */
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) onChange(event);
    field.onChange(event);
  };

  return (
    <div className={'col-12' + (wrapClassName ? ` ${wrapClassName}` : '')}>
      <div className="name">{label}</div>
      <Input
        {...field}
        {...props}
        type="text"
        className={(className ? ` ${className}` : '') + (meta.error && meta.touched ? ' field--invalid' : '')}
        onChange={handleChange}
      />
      {meta.error && meta.touched && (
        <div className="notes warn mt-2">{meta.error}</div>
      )}
      {tips?.map((tip, index) => (
        <div className="notes mt-2" key={index}>
          {`*${tip}`}
        </div>
      ))}
    </div>
  );
};

export default InputTextField;
